import axiosBackend from "../config/axios/axios-back-end";

export const getAllIndexes = async () => {
  const res = await axiosBackend.get("/api/indexes");
  return res.data;
};

export const getIndexFormats = async () => {
  const res = await axiosBackend.get("/api/indexformat");
  return res.data;
};

export const createIndexList = async (indexData) => {
  const result = await axiosBackend.post("/api/indexes/createlist", {
    data: indexData,
  });
  return result.data;
};

export default { getAllIndexes, getIndexFormats, createIndexList };
